import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import type { HomePage } from '../../api/api-types';
import type { Loadable } from '../../guards/ngrx-loader.guard';
import { actions } from './home.actions';

interface HomeState {
    home: Loadable<HomePage>;
}

const initialState: HomeState = {
    home: null,
};

export const state = createFeature({
    name: 'home',
    reducer: createReducer(
        initialState,
        on(
            actions.loadHome,
            (state): HomeState => ({
                ...state,
                home: null,
            }),
        ),
        on(
            actions.loadHomeSuccess,
            (state, { home }): HomeState => ({
                ...state,
                home,
            }),
        ),
        on(
            actions.loadHomeFailure,
            (state): HomeState => ({
                ...state,
                home: false,
            }),
        ),
    ),
    extraSelectors: (baseSelectors) => {
        const selectIsLoadingHome = createSelector(baseSelectors.selectHome, (home) => home === null);
        const selectLoadedHome = createSelector(baseSelectors.selectHome, (home) => home as HomePage);
        const selectHomeModelList = createSelector(selectLoadedHome, (home) => home.modelList);
        const selectHomeCampaigns = createSelector(selectLoadedHome, (home) => home.campaigns);
        const selectHomeTeasers = createSelector(selectLoadedHome, (home) => home.teasers);
        const selectHcmTeaser = createSelector(selectLoadedHome, (home) => home.hcmTeaser);
        const selectHomeContactEmployee = createSelector(selectLoadedHome, (home) => home.contactEmployee);
        const selectHomeImageTextContent = createSelector(selectLoadedHome, (home) => home.imageTextContent);

        return {
            selectIsLoadingHome,
            selectLoadedHome,
            selectHomeModelList,
            selectHomeCampaigns,
            selectHomeTeasers,
            selectHcmTeaser,
            selectHomeContactEmployee,
            selectHomeImageTextContent,
        };
    },
});
